/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type {
  TraderVaultLibTester,
  TraderVaultLibTesterInterface
} from '../TraderVaultLibTester'

const _abi = [
  {
    inputs: [],
    name: 'clear',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'spotPrice',
            type: 'uint128'
          },
          {
            internalType: 'int256[2]',
            name: 'tradePrices',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'fundingRates',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'amountsFundingPaidPerPosition',
            type: 'int256[2]'
          }
        ],
        internalType: 'struct IPerpetualMarketCore.TradePriceInfo',
        name: '_tradePriceInfo',
        type: 'tuple'
      }
    ],
    name: 'getMinCollateral',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getNumOfSubVault',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'spotPrice',
            type: 'uint128'
          },
          {
            internalType: 'int256[2]',
            name: 'tradePrices',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'fundingRates',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'amountsFundingPaidPerPosition',
            type: 'int256[2]'
          }
        ],
        internalType: 'struct IPerpetualMarketCore.TradePriceInfo',
        name: '_tradePriceInfo',
        type: 'tuple'
      }
    ],
    name: 'getPositionValue',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_subVaultId',
        type: 'uint256'
      }
    ],
    name: 'getSubVault',
    outputs: [
      {
        components: [
          {
            internalType: 'int128[2]',
            name: 'positionPerpetuals',
            type: 'int128[2]'
          },
          {
            internalType: 'uint128[2]',
            name: 'entryPrices',
            type: 'uint128[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'entryFundingFee',
            type: 'int256[2]'
          }
        ],
        internalType: 'struct TraderVaultLib.SubVault',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'r',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'spotPrice',
            type: 'uint128'
          },
          {
            internalType: 'int256[2]',
            name: 'tradePrices',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'fundingRates',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'amountsFundingPaidPerPosition',
            type: 'int256[2]'
          }
        ],
        internalType: 'struct IPerpetualMarketCore.TradePriceInfo',
        name: '_tradePriceInfo',
        type: 'tuple'
      }
    ],
    name: 'testCheckVaultIsLiquidatable',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_minCollateral',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: 'liquidationFee',
        type: 'int256'
      }
    ],
    name: 'testDecreaseLiquidationReward',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int128[2]',
        name: '_tradeAmounts',
        type: 'int128[2]'
      },
      {
        components: [
          {
            internalType: 'uint128',
            name: 'spotPrice',
            type: 'uint128'
          },
          {
            internalType: 'int256[2]',
            name: 'tradePrices',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'fundingRates',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'amountsFundingPaidPerPosition',
            type: 'int256[2]'
          }
        ],
        internalType: 'struct IPerpetualMarketCore.TradePriceInfo',
        name: '_tradePriceInfo',
        type: 'tuple'
      }
    ],
    name: 'testGetMinCollateralToAddPosition',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'testSetInsolvencyFlagIfNeeded',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_amount',
        type: 'int256'
      },
      {
        components: [
          {
            internalType: 'uint128',
            name: 'spotPrice',
            type: 'uint128'
          },
          {
            internalType: 'int256[2]',
            name: 'tradePrices',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'fundingRates',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'amountsFundingPaidPerPosition',
            type: 'int256[2]'
          }
        ],
        internalType: 'struct IPerpetualMarketCore.TradePriceInfo',
        name: '_tradePriceInfo',
        type: 'tuple'
      }
    ],
    name: 'testUpdateUsdcPosition',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_subVaultId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_amountAsset',
        type: 'int128'
      },
      {
        internalType: 'uint256',
        name: '_tradePrice',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_fundingFeePerPosition',
        type: 'int128'
      }
    ],
    name: 'testUpdateVault',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'traderVault',
    outputs: [
      {
        internalType: 'int128',
        name: 'positionUsdc',
        type: 'int128'
      },
      {
        internalType: 'bool',
        name: 'isInsolvent',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const _bytecode =
  '0x608060405234801561001057600080fd5b506119ac806100206000396000f3fe608060405234801561001057600080fd5b50600436106100cf5760003560e01c806352efea6e1161008c5780636c8ae38c116100665780636c8ae38c1461019e5780636d8dfd79146101a657806381cd834e146101ae578063e81d15bc146101c1576100cf565b806352efea6e1461017057806365b43352146101785780636b6e106e1461018b576100cf565b80630b35dccc146100d457806312fc1658146100fd57806330050fbd14610112578063323f3b0b146101325780633333f5fc1461015257806351ed0ee31461015a575b600080fd5b6100e76100e236600461168b565b6101d4565b6040516100f49190611730565b60405180910390f35b61011061010b36600461165e565b610362565b005b6101256101203660046116a6565b6103f5565b6040516100f49190611759565b61014561014036600461158c565b61051d565b6040516100f49190611750565b6101456106ad565b6101626106b3565b6040516100f492919061173b565b6101106106c6565b61011061018636600461163d565b6106f9565b6101106101993660046116be565b61078f565b610145610829565b61011061082f565b6101456101bc36600461168b565b610899565b6101456101cf36600461168b565b610a1f565b6040805160608101825260008054600f90810b810b900b8252600180548451602082810282018101909652818152929461035a94938693828601939192909190859084015b8282101561033b576000848152602090206040805160a0810190915290600484020181606081018260028282826020028201916000905b82829054906101000a9004600f0b600f0b81526020019060100190602082600f01049283019260010382029150808411610250575050509284525050604080518082019182905260209093019291506001840190600290826000855b82829054906101000a90046001600160801b03166001600160801b031681526020019060100190602082600f010492830192600103820291508084116102ac5750505092845250506040805180820191829052602090930192915060028481019182845b8154815260200190600101908083116103105750505050508152505081526020019060010190610219565b505050908252506002919091015460ff16151560209091015283610ba5565b90505b919050565b60405163e69e266d60e01b815273__$b139f62619843504e83620ab3c72958bdd$__9063e69e266d9061039e90600090869086906004016117e8565b60206040518083038186803b1580156103b657600080fd5b505af41580156103ca573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906103ee9190611625565b6003555050565b6103fd6113bf565b600180548390811061040b57fe5b600091825260209091206040805160a08101909152916004020181606081018260028282826020028201916000905b82829054906101000a9004600f0b600f0b81526020019060100190602082600f0104928301926001038202915080841161043a575050509284525050604080518082019182905260209093019291506001840190600290826000855b82829054906101000a90046001600160801b03166001600160801b031681526020019060100190602082600f010492830192600103820291508084116104965750505092845250506040805180820191829052602090930192915060028481019182845b8154815260200190600101908083116104fa575050505050815250509050919050565b6040805160608101825260008054600f90810b810b900b825260018054845160208281028201810190965281815292946106a494938693828601939192909190859084015b82821015610684576000848152602090206040805160a0810190915290600484020181606081018260028282826020028201916000905b82829054906101000a9004600f0b600f0b81526020019060100190602082600f01049283019260010382029150808411610599575050509284525050604080518082019182905260209093019291506001840190600290826000855b82829054906101000a90046001600160801b03166001600160801b031681526020019060100190602082600f010492830192600103820291508084116105f55750505092845250506040805180820191829052602090930192915060028481019182845b8154815260200190600101908083116106595750505050508152505081526020019060010190610562565b505050908252506002919091015460ff1615156020909101528484610bc6565b90505b92915050565b60015490565b600054600254600f9190910b9060ff1682565b600080546fffffffffffffffffffffffffffffffff19168155806106eb6001826113f1565b50600201805460ff19169055565b60405163652aa48360e01b815273__$b139f62619843504e83620ab3c72958bdd$__9063652aa4839061073590600090869086906004016117d2565b60206040518083038186803b15801561074d57600080fd5b505af4158015610761573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107859190611625565b600f0b6003555050565b60405163a8ffb3b960e01b815273__$b139f62619843504e83620ab3c72958bdd$__9063a8ffb3b9906107d19060009089908990899089908990600401611848565b60206040518083038186803b1580156107e957600080fd5b505af41580156107fd573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108219190611625565b505050505050565b60035481565b604051630de022c160e11b815273__$b139f62619843504e83620ab3c72958bdd$__90631bc045829061086790600090600401611750565b60006040518083038186803b15801561087f57600080fd5b505af4158015610893573d6000803e3d6000fd5b50505050565b6040805160608101825260008054600f90810b810b900b8252600180548451602082810282018101909652818152929461035a94938693828601939192909190859084015b82821015610a00576000848152602090206040805160a0810190915290600484020181606081018260028282826020028201916000905b82829054906101000a9004600f0b600f0b81526020019060100190602082600f01049283019260010382029150808411610915575050509284525050604080518082019182905260209093019291506001840190600290826000855b82829054906101000a90046001600160801b03166001600160801b031681526020019060100190602082600f010492830192600103820291508084116109715750505092845250506040805180820191829052602090930192915060028481019182845b8154815260200190600101908083116109d557505050505081525050815260200190600101906108de565b505050908252506002919091015460ff16151560209091015283610c50565b6040805160608101825260008054600f90810b810b900b8252600180548451602082810282018101909652818152929461035a94938693828601939192909190859084015b82821015610b86576000848152602090206040805160a0810190915290600484020181606081018260028282826020028201916000905b82829054906101000a9004600f0b600f0b81526020019060100190602082600f01049283019260010382029150808411610a9b575050509284525050604080518082019182905260209093019291506001840190600290826000855b82829054906101000a90046001600160801b03166001600160801b031681526020019060100190602082600f01049283019260010382029150808411610af75750505092845250506040805180820191829052602090930192915060028481019182845b815481526020019060010190808311610b5b5750505050508152505081526020019060010190610a64565b505050908252506002919091015460ff16151560209091015283610c70565b600080610bb28484610c70565b9050610bbe8484610c50565b139392505050565b600080610bd285610cc4565b905060005b6002811015610c3c57610c19610c14868360028110610bf257fe5b6020020151600f0b848460028110610c0657fe5b6020020151600f0b90610d0b565b610d70565b828260028110610c2557fe5b600f92830b90920b60209092020152600101610bd7565b50610c478184610dd5565b95945050505050565b600080610c5c84610cc4565b9050610c688184610dd5565b949350505050565b8151600090600f0b815b846020015151811015610cbc57610cb2610cab86602001518381518110610c9d57fe5b602002602001015186610f5c565b8390610d0b565b9150600101610c7a565b509392505050565b610ccc611415565b60005b6002811015610d0557610ce28382610f79565b828260028110610cee57fe5b600f92830b90920b60209092020152600101610ccf565b50919050565b6000828201818312801590610d205750838112155b80610d355750600083128015610d3557508381125b6106a45760405162461bcd60e51b81526004018080602001828103825260218152602001806118a16021913960400191505060405180910390fd5b60006f7fffffffffffffffffffffffffffffff198212158015610d9657506001607f1b82125b610dd15760405162461bcd60e51b815260040180806020018281038252602781526020018061187a6027913960400191505060405180910390fd5b5090565b600080610e216305f5e100610e1b610e0a662386f26fc100008760400151600160028110610dff57fe5b602002015190610d0b565b86516001600160801b031690610fda565b90611083565b90506000610e98610e93610e60662386f26fc10000610e1b610e55662386f26fc100008a60400151600060028110610dff57fe5b8a51600f0b90610fda565b610e8d68056bc75e2d63100000610e1b6002610e878c600160200201518a90600f0b610fda565b90610fda565b90610d0b565b61113b565b9050610ed2610ecb610e9369d3c21bcecceda1000000610e1b8960016020020151600f0b610e876002816101f48b610fda565b829061114e565b9050600064e8d4a51000610f0883610f0288600001516001600160801b03166101f46111a890919063ffffffff16565b906111a8565b81610f0f57fe5b87519190049150600f0b151580610f2c57506020860151600f0b15155b8015610f3c57506404a817c80081105b15610f4957506404a817c8005b610f5281611201565b9695505050505050565b60006106a4610f6f848460600151611245565b610e8d858561126c565b6000805b836020015151811015610fd357610fc9610c1485602001518381518110610fa057fe5b6020026020010151600001518560028110610fb757fe5b6020020151600f85810b91900b610d0b565b9150600101610f7d565b5092915050565b600082610fe9575060006106a7565b82600019148015610ffd5750600160ff1b82145b156110395760405162461bcd60e51b81526004018080602001828103825260278152602001806119046027913960400191505060405180910390fd5b8282028284828161104657fe5b05146106a45760405162461bcd60e51b81526004018080602001828103825260278152602001806119046027913960400191505060405180910390fd5b6000816110d7576040805162461bcd60e51b815260206004820181905260248201527f5369676e6564536166654d6174683a206469766973696f6e206279207a65726f604482015290519081900360640190fd5b816000191480156110eb5750600160ff1b83145b156111275760405162461bcd60e51b81526004018080602001828103825260218152602001806118c26021913960400191505060405180910390fd5b600082848161113257fe5b05949350505050565b600080821215610dd1578160000361035a565b6000828201838110156106a4576040805162461bcd60e51b815260206004820152601b60248201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604482015290519081900360640190fd5b6000826111b7575060006106a7565b828202828482816111c457fe5b04146106a45760405162461bcd60e51b81526004018080602001828103825260218152602001806118e36021913960400191505060405180910390fd5b6000600160ff1b8210610dd15760405162461bcd60e51b815260040180806020018281038252602881526020018061192b6028913960400191505060405180910390fd5b60008060005b6002811015610cbc57611262610cab868387611293565b915060010161124b565b60008060005b6002811015610cbc57611289610cab8683876112f3565b9150600101611272565b6000806112e0856000015185600281106112a957fe5b6020020151600f0b610e878587600281106112c057fe5b6020020151886040015188600281106112d557fe5b60200201519061135a565b9050610c4781662386f26fc10000611083565b60008061134a8560000151856002811061130957fe5b6020020151600f0b610e8761133a8860200151886002811061132757fe5b60200201516001600160801b0316611201565b866020015188600281106112d557fe5b6305f5e100900595945050505050565b600081830381831280159061136f5750838113155b80611384575060008312801561138457508381135b6106a45760405162461bcd60e51b81526004018080602001828103825260248152602001806119536024913960400191505060405180910390fd5b60405180606001604052806113d2611415565b81526020016113df611415565b81526020016113ec611415565b905290565b50805460008255600402906000526020600020908101906114129190611433565b50565b60405180604001604052806002906020820280368337509192915050565b80821115610dd1576000611447828261146c565b61145560018301600061146c565b611463600283016000611473565b50600401611433565b5060009055565b506000815560010160009055565b600082601f830112611491578081fd5b6040516040810181811067ffffffffffffffff821117156114ae57fe5b80604052508083856040860111156114c4578384fd5b835b60028110156114e55781358352602092830192909101906001016114c6565b509195945050505050565b8035600f81900b811461035d57600080fd5b600060e08284031215611513578081fd5b6040516080810181811067ffffffffffffffff8211171561153057fe5b60405290508082356001600160801b038116811461154d57600080fd5b815261155c8460208501611481565b602082015261156e8460608501611481565b60408201526115808460a08501611481565b60608201525092915050565b600080610120838503121561159f578182fd5b83601f8401126115ad578182fd5b6040516040810181811067ffffffffffffffff821117156115ca57fe5b8060405250808460408601878111156115e1578586fd5b855b600281101561160a576115f5836114f0565b845260209384019392909201916001016115e3565b508395506116188882611502565b9450505050509250929050565b600060208284031215611636578081fd5b5051919050565b6000806040838503121561164f578182fd5b50508035926020909101359150565b6000806101008385031215611671578182fd5b823591506116828460208501611502565b90509250929050565b600060e0828403121561169c578081fd5b6106a48383611502565b6000602082840312156116b7578081fd5b5035919050565b600080600080600060a086880312156116d5578081fd5b85359450602086013593506116ec604087016114f0565b925060608601359150611701608087016114f0565b90509295509295909350565b8060005b6002811015610893578151845260209384019390910190600101611711565b901515815260200190565b600f9290920b82521515602082015260400190565b90815260200190565b815160c08201908260005b6002811015611786578251600f0b825260209283019290910190600101611764565b5050506020808401516040840160005b60028110156117bc5782516001600160801b031682529183019190830190600101611796565b505050506040830151610fd3608084018261170d565b9283526020830191909152604082015260600190565b838152602080820184905282516001600160801b03166040830152820151610120820190611819606084018261170d565b50604083015161182c60a084018261170d565b50606083015161183f60e084018261170d565b50949350505050565b95865260208601949094526040850192909252600f90810b606085015260808401919091520b60a082015260c0019056fe53616665436173743a2076616c756520646f65736e27742066697420696e2031323820626974735369676e6564536166654d6174683a206164646974696f6e206f766572666c6f775369676e6564536166654d6174683a206469766973696f6e206f766572666c6f77536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f775369676e6564536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f7753616665436173743a2076616c756520646f65736e27742066697420696e20616e20696e743235365369676e6564536166654d6174683a207375627472616374696f6e206f766572666c6f77a264697066735822122090c19fb85f6d830d3c6f0edbd9b610da6bfc1e3218eb3cdcb190d54ea6801ab364736f6c63430007060033'

type TraderVaultLibTesterConstructorParams =
  | [
      linkLibraryAddresses: TraderVaultLibTesterLibraryAddresses,
      signer?: Signer
    ]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: TraderVaultLibTesterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  )
}

export class TraderVaultLibTester__factory extends ContractFactory {
  constructor(...args: TraderVaultLibTesterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      const [linkLibraryAddresses, signer] = args
      super(
        _abi,
        TraderVaultLibTester__factory.linkBytecode(linkLibraryAddresses),
        signer
      )
    }
  }

  static linkBytecode(
    linkLibraryAddresses: TraderVaultLibTesterLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$b139f62619843504e83620ab3c72958bdd\\$__', 'g'),
      linkLibraryAddresses['contracts/lib/TraderVaultLib.sol:TraderVaultLib']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TraderVaultLibTester> {
    return super.deploy(overrides || {}) as Promise<TraderVaultLibTester>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): TraderVaultLibTester {
    return super.attach(address) as TraderVaultLibTester
  }
  connect(signer: Signer): TraderVaultLibTester__factory {
    return super.connect(signer) as TraderVaultLibTester__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): TraderVaultLibTesterInterface {
    return new utils.Interface(_abi) as TraderVaultLibTesterInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TraderVaultLibTester {
    return new Contract(address, _abi, signerOrProvider) as TraderVaultLibTester
  }
}

export interface TraderVaultLibTesterLibraryAddresses {
  ['contracts/lib/TraderVaultLib.sol:TraderVaultLib']: string
}
